import sedanImg from "../assets/img/common/modelos/AllNewK3Sedan.webp";
import crossImg from "../assets/img/common/modelos/AllNewK3Cross.webp";
import SeltosImg from "../assets/img/common/modelos/Seltos.webp";
import SportageImg from "../assets/img/common/modelos/Sportage.webp";
import carnivalImg from "../assets/img/common/modelos/Carnival.webp";
import k2500Img from "../assets/img/common/modelos/K2500.webp";

const CAR_MODELS = [
  {
    id: 24,
    name: "All-new K3 Sedán",
    image: sedanImg,
  },
  {
    id: 25,
    name: "All-new K3 Cross",
    image: crossImg,
  },
  {
    id: 23,
    name: "Seltos",
    image: SeltosImg,
  },
  {
    id: 1,
    name: "Sportage",
    image: SportageImg,
  },
  {
    id: 7,
    name: "Carnival",
    image: carnivalImg,
  },
  {
    id: 8,
    name: "K2500",
    image: k2500Img,
  },
];

export default CAR_MODELS;
